import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

const ForgotPassword = () => {
  const [step, setStep] = useState(1); // Step 1: Enter email/phone, Step 2: Verify OTP
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");

  const handleSendOtp = () => {
    if (!emailOrPhone) {
      setError("Email or phone number is required.");
      return;
    }
    setError("");
    console.log("Sending OTP to:", emailOrPhone);
    // Simulate OTP sending
    setStep(2);
  };

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically focus the next input
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleVerifyOtp = () => {
    if (otp.some((digit) => digit === "") || otp.join("").length !== 4) {
      setError("Please enter a valid 4-digit OTP.");
      return;
    }
    setError("");
    console.log("Verifying OTP:", otp.join(""));
    // Simulate OTP verification
    alert("OTP verified! You can now log in.");
    window.location.href = "/login"; // Redirect to login page
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="card p-4" style={{ width: "30rem" }}>
        <h2 className="text-center mb-4">Forgot Password</h2>
        {step === 1 && (
          <div>
            <TextField
              fullWidth
              label="Email or Phone"
              value={emailOrPhone}
              onChange={(e) => setEmailOrPhone(e.target.value)}
              error={!!error}
              helperText={error}
            />
            <div className="d-grid gap-2 mt-3">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSendOtp}
              >
                Send OTP
              </Button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div>
            <Box display="flex" justifyContent="center" gap={2} mb={2}>
              {otp.map((digit, index) => (
                <TextField
                  key={index}
                  id={`otp-${index}`}
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: "center", fontSize: "1.5rem" },
                  }}
                  sx={{ width: "3rem" }}
                />
              ))}
            </Box>
            {error && (
              <p style={{ color: "red", fontSize: "0.875rem", textAlign: "center" }}>
                {error}
              </p>
            )}
            <div className="d-grid gap-2 mt-3">
              <Button
                variant="contained"
                color="primary"
                onClick={handleVerifyOtp}
              >
                Confirm
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
